import layout from './layout/LayoutConfig';

const FuseLayoutConfigs = { layout };

export default FuseLayoutConfigs;
